import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import { isNil } from '@grandvisionhq/utils';
import { useCartStorage } from '../../../hooks/use-cart-storage.js';
import { RemoveVoucherCode } from './RemoveVoucherCode.js';
import { REMOVE_CART_VOUCHER_CODES } from '../../../operations/mutations/remove-cart-voucher-codes.js';
import { GET_CART } from '../../../operations/queries/get-cart.js';

var RemoveVoucherCodeContainer = (_param)=>{
    var { voucherCode  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "voucherCode"
    ]);
    const [{ cartId  }] = useCartStorage();
    const [removeCartVoucherCodes] = useMutation(REMOVE_CART_VOUCHER_CODES);
    const handleRemove = React.useCallback(()=>{
        if (!cartId || !voucherCode) {
            return;
        }
        removeCartVoucherCodes({
            variables: {
                cartInput: {
                    cartId,
                    voucherCodes: [
                        voucherCode
                    ]
                }
            },
            update (cache, { data  }) {
                if (data && data.removeCartVoucherCodes.success === true) {
                    const newCart = data.removeCartVoucherCodes.cart;
                    cache.writeQuery({
                        query: GET_CART,
                        variables: {
                            id: cartId
                        },
                        data: newCart
                    });
                }
            }
        });
    }, [
        cartId,
        removeCartVoucherCodes,
        voucherCode
    ]);
    if (isNil(cartId) || !voucherCode) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(RemoveVoucherCode, swcHelpers.extends({
        onRemove: handleRemove,
        voucherCode: voucherCode
    }, rest));
};

export { RemoveVoucherCodeContainer };
//# sourceMappingURL=RemoveVoucherCodeContainer.js.map
